import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { Button } from '@x5-react-uikit/core';

import { ClientListFilter } from 'types/clientList';
import { Container, PageHeader, Pagination } from 'components';
import { ForRole } from 'containers';
import { PAGE_LIMIT } from 'config/constants';
import { Role } from 'types/api/user/dictionaries';
import clientListApi from 'store/services/clientListApi';
import TableClientsList from 'modules/clientList/UI/TableClientsList';

import { NEW_FILE } from '../../utils/dictionaries';
import { transformToListRequestQuery } from '../../utils';
import { useFiltration, usePagination, useSearchParams } from './hooks';
import ModalDownload from '../../UI/ModalDownload';
import TableFilters from './TableFilters';

const ClientList: React.FC = () => {
  const [clientId, setClientId] = useState<string | null>(undefined);
  const [searchParams, setSearchParams] = useSearchParams();
  const pagination = usePagination(searchParams.pagination);
  const filtration = useFiltration({
    filters: searchParams.filters,
    sorters: searchParams.sorters,
  });

  const args = {
    ...filtration.filters,
    ...filtration.sorters,
    page: pagination.page - 1,
    limit: pagination.limit,
  } as ClientListFilter;

  const { data, isLoading } = clientListApi.useGetListQuery(
    transformToListRequestQuery(args),
    {
      pollingInterval: 5000,
    }
  );

  const handleFiltersChange = (newFilters) => {
    filtration.setFilters(newFilters);
    pagination.setPage(1);
  };

  const handleSortChange = (values) => {
    filtration.setSorters(values);
  };

  const handleModalOpen = () => {
    setClientId(NEW_FILE);
  };

  const handleModalClose = () => {
    setClientId(undefined);
  };

  const items = data?.result.items || [];
  const count = data?.result.total_elements || 0;
  const totalPages = Math.ceil(count / pagination.limit);

  useEffect(() => {
    setSearchParams(args);
  }, [JSON.stringify(args)]);

  return (
    <Container>
      <PageHeader title="Списки на профилирование">
        <ForRole role={Role.Partner}>
          <Button size="medium" variant="primary" onClick={handleModalOpen}>
            Загрузить список
          </Button>
        </ForRole>
      </PageHeader>

      <TableFilters
        filters={filtration.filters}
        onConfirm={handleFiltersChange}
      />

      <TableClientsList
        isLoading={isLoading}
        items={items}
        onSortChange={handleSortChange}
        onUploadClick={(x) => setClientId(x)}
        sort={filtration.sorters}
      />

      <Box mt={11} />

      <Pagination
        active={pagination.page}
        count={totalPages * PAGE_LIMIT}
        limit={PAGE_LIMIT}
        onPageChange={pagination.setPage}
      />

      <ModalDownload
        key={clientId}
        isOpen={Boolean(clientId)}
        clientId={clientId}
        onClose={handleModalClose}
      />
    </Container>
  );
};

export default ClientList;
